import { AssetType } from '../enums/AssetType'
import Company from './Company'
import Device from './Device'
import Level from './Level'
import Lift from './Lift'
import Project from './Project'
import RuuviTag from './RuuviTag'
import { Upload } from './Upload'

export enum AssetStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive'
}

type Asset = {
  id: string
  type: AssetType
  name: string
  description: string | null
  status: AssetStatus
  companyId: number | null
  projectId: number | null
  levelId: number | null
  liftId: number | null
  photoId: string | null
  photoUrl?: string
  deletedAt: Date | null
  company?: Company | null
  project?: Project | null
  level?: Level | null
  lift?: Lift | null
  photo?: Upload | null
  ruuviTag?: RuuviTag
  ruuviTagId?: string | null
  device?: Device
  deviceName?: string | null
  createdAt: string
  updatedAt: string
  attachedAt?: string | null
  detachedAt?: string | null
}

export default Asset
